/**
 *
 *	🚨🚨🚨 THIS FILE IS AUTOGENERATED 🚨🚨🚨
 *	TO MAKE CHANGES - PLEASE EDIT "./src/templates/components/Icon.tsx.ejs"
 *
 */

import React, { FC } from "react";
import cx from "clsx";
import { IconProps } from "../types";

const IconsList = [
	"accessibility",
	"accommodations",
	"add-trip--o",
	"adults",
	"airline-travel-info",
	"airport-lounge",
	"airport-services",
	"airport-transfer",
	"alert--o",
	"alert",
	"alternate-carriers",
	"anchor",
	"angle-down",
	"arrow-double",
	"arrow-down",
	"arrow-left",
	"arrow-right",
	"arrow-tail",
	"arrow-thick-double-left",
	"arrow-thick-double-right",
	"arrow-thick-down",
	"arrow-thick",
	"arrow-up",
	"award",
	"baggage",
	"bell-ring",
	"bell",
	"boarding-pass",
	"booking-summary",
	"brochure",
	"budget",
	"bus",
	"calendar",
	"call--o",
	"call",
	"canada-flag",
	"canada-leaf",
	"caret-up",
	"chat-bubble--o",
	"chat-bubble",
	"chat",
	"checked--n",
	"checked--o",
	"checked",
	"children",
	"close--n",
	"close--o",
	"close",
	"contacts-faq",
	"credit-card",
	"crown",
	"cruise-overview",
	"cruise",
	"deals",
	"deck-plan",
	"delete--o",
	"delete",
	"destination-support",
	"domestic-travel",
	"download",
	"duration",
	"edit--n",
	"edit--o",
	"edit-profile",
	"edit",
	"email",
	"entertainment",
	"excursions",
	"external-link",
	"extra-inclusions",
	"eye-slash",
	"facebook",
	"faq--o",
	"faq-alt",
	"faq",
	"favorite--o",
	"favorite-tips",
	"favorite",
	"favotite--c",
	"feedback",
	"filter",
	"flight-status--o",
	"flight-status",
	"flight",
	"friends-and-family",
	"gallery",
	"golf",
	"groups",
	"handbag",
	"help--o",
	"help",
	"hot-deal",
	"hotel--o",
	"hotel-check-in",
	"hotel",
	"ideal-for",
	"info--n",
	"info--o",
	"info",
	"information--o",
	"information",
	"instagram",
	"insurance",
	"international",
	"itineraries",
	"list",
	"luggage",
	"map",
	"meal",
	"member-perks--o",
	"menu",
	"minus--n",
	"minus--o",
	"minus",
	"my-account--o",
	"my-account",
	"my-booking--o",
	"my-bookings",
	"onboard-facilities",
	"optional-services",
	"overview",
	"packages",
	"parking",
	"passenger-care",
	"passengers",
	"passport",
	"password-hidden",
	"password",
	"pause",
	"photo--o",
	"photo",
	"pinterest",
	"plane-up",
	"play",
	"plus--n",
	"plus--o",
	"plus",
	"policies-vacation-checklist",
	"pre-order-meal",
	"pre-order",
	"price--n",
	"price--o",
	"price-drop-guarantee",
	"price",
	"print",
	"promotion",
	"protect--o",
	"protect",
	"q-and-a",
	"refresh--o",
	"refresh",
	"room-guests",
	"roundtrip",
	"route-marker",
	"search",
	"seat-map",
	"seat-section",
	"share",
	"sort",
	"special-assistance",
	"special-packages",
	"star-badge",
	"star-half",
	"star",
	"sunwing-cafe",
	"thumbs-up",
	"tiktok",
	"timer",
	"tip",
	"tips",
	"travel-requirement",
	"travel-tips",
	"trending",
	"twitter",
	"upgrades",
	"vacation-finder",
	"video--o",
	"video",
	"voucher--o",
	"voucher",
	"washroom--o",
	"washroom",
	"web-check-in",
	"weddings",
	"wifi",
	"youtube",
] as const;

const Icon: FC<
	IconProps & {
		name: typeof IconsList[number];
	}
> = ({
	iconPrefix = "swg-icon",
	name,
	className,
	title,
	hidden,
	fixedWidth,
	rotate,
	size,
	animate,
}) => (
	<span
		className={cx(iconPrefix, `${iconPrefix}-${name}`, className, {
			[`${iconPrefix}--${size}`]: size,
			[`${iconPrefix}--fw`]: fixedWidth,
			[`${iconPrefix}--r-${rotate}`]: rotate,
			[`${iconPrefix}--${animate}`]: animate,
		})}
		aria-label={title}
		aria-hidden={hidden}
	/>
);

Icon.displayName = "Icon";

export default Icon;
export { Icon };
